import { t } from 'i18next';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

const RequiredFieldMessage = () => {
  return (
    <Box sx={{ display: 'flex', padding: '1rem 0', justifyContent: 'end' }}>
      <Typography sx={{ opacity: '.6', fontSize: '.75rem' }} >
        <>(<span style={{ color: 'rgba(240, 0, 0)' }}>*</span>) {t('requiredFields')}</>
      </Typography>
    </Box>
  );
};

export default RequiredFieldMessage;
